"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.icons = exports.Icon = void 0;

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _ = require(".");

var _alert = _interopRequireDefault(require("../assets/icons/alert.svg"));

var _arrow = _interopRequireDefault(require("../assets/icons/arrow.svg"));

var _blog = _interopRequireDefault(require("../assets/icons/blog.svg"));

var _caret = _interopRequireDefault(require("../assets/icons/caret.svg"));

var _checkmark = _interopRequireDefault(require("../assets/icons/checkmark.svg"));

var _copy = _interopRequireDefault(require("../assets/icons/copy.svg"));

var _external = _interopRequireDefault(require("../assets/icons/external.svg"));

var _help = _interopRequireDefault(require("../assets/icons/help.svg"));

var _home = _interopRequireDefault(require("../assets/icons/home.svg"));

var _info = _interopRequireDefault(require("../assets/icons/info.svg"));

var _link = _interopRequireDefault(require("../assets/icons/link.svg"));

var _lock = _interopRequireDefault(require("../assets/icons/lock.svg"));

var _minus = _interopRequireDefault(require("../assets/icons/minus.svg"));

var _plus = _interopRequireDefault(require("../assets/icons/plus.svg"));

var _present = _interopRequireDefault(require("../assets/icons/present.svg"));

var _press = _interopRequireDefault(require("../assets/icons/press.svg"));

var _question = _interopRequireDefault(require("../assets/icons/question.svg"));

var _search = _interopRequireDefault(require("../assets/icons/search.svg"));

var _support = _interopRequireDefault(require("../assets/icons/support.svg"));

var _team = _interopRequireDefault(require("../assets/icons/team.svg"));

var _tool = _interopRequireDefault(require("../assets/icons/tool.svg"));

var _waiting = _interopRequireDefault(require("../assets/icons/waiting.svg"));

var _warning = _interopRequireDefault(require("../assets/icons/warning.svg"));

var _bitcoin = _interopRequireDefault(require("../assets/logos/bitcoin.svg"));

var _discord = _interopRequireDefault(require("../assets/logos/discord.svg"));

var _ether = _interopRequireDefault(require("../assets/logos/ether.svg"));

var _facebook = _interopRequireDefault(require("../assets/logos/facebook.svg"));

var _github = _interopRequireDefault(require("../assets/logos/github.svg"));

var _linkedin = _interopRequireDefault(require("../assets/logos/linkedin.svg"));

var _medium = _interopRequireDefault(require("../assets/logos/medium.svg"));

var _reddit = _interopRequireDefault(require("../assets/logos/reddit.svg"));

var _telegram = _interopRequireDefault(require("../assets/logos/telegram.svg"));

var _twitter = _interopRequireDefault(require("../assets/logos/twitter.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["type", "width", "fill"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var icons = {
  alert: _alert["default"],
  arrow: _arrow["default"],
  blog: _blog["default"],
  caret: _caret["default"],
  checkmark: _checkmark["default"],
  copy: _copy["default"],
  external: _external["default"],
  help: _help["default"],
  home: _home["default"],
  info: _info["default"],
  link: _link["default"],
  lock: _lock["default"],
  minus: _minus["default"],
  plus: _plus["default"],
  present: _present["default"],
  press: _press["default"],
  question: _question["default"],
  search: _search["default"],
  support: _support["default"],
  team: _team["default"],
  tool: _tool["default"],
  waiting: _waiting["default"],
  warning: _warning["default"],
  bitcoin: _bitcoin["default"],
  discord: _discord["default"],
  ether: _ether["default"],
  facebook: _facebook["default"],
  github: _github["default"],
  linkedin: _linkedin["default"],
  medium: _medium["default"],
  reddit: _reddit["default"],
  telegram: _telegram["default"],
  twitter: _twitter["default"]
};
exports.icons = icons;

var Icon = function Icon(_ref) {
  var type = _ref.type,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '15' : _ref$width,
      fill = _ref.fill,
      props = _objectWithoutProperties(_ref, _excluded);

  if (fill) {
    return (0, _jsxRuntime.jsx)(_.Box, _objectSpread({
      as: _reactInlinesvg["default"],
      src: icons[type],
      width: width,
      fill: fill
    }, props));
  }

  return (0, _jsxRuntime.jsx)(_.Box, _objectSpread({
    as: "img",
    src: icons[type],
    width: width
  }, props));
};

exports.Icon = Icon;